class NfeConsultaPortalModal {
    constructor(gql, scope) {
        this.gql = gql
        this.apply = (fn) => scope.$apply(fn)
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeConsultaPortalModal', {
        controller: ['gql', '$scope', NfeConsultaPortalModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal title="Portal da Nota Fiscal Eletrônica" close="$ctrl.close">
            <modal-body>
                <div style="position: relative; height: 0; overflow: hidden; padding-bottom: 75%;">
                    <iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
                            src="http://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&tipoConteudo=XbSeqxE8pl8=">
                    </iframe>
                </div>
            </modal-body>
            <modal-footer>
                <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
            </modal-footer>
        </modal>
        `
    })
